import { ObjectID } from 'bson';

export const objectIdComparator = (a: ObjectID, b: ObjectID | string) => a.equals(b);

export const includesObjectID = (objectIds: ObjectID[], objectId: ObjectID | string) => {
  const myObjectIdComparator = (element: ObjectID) => element.equals(objectId);
  return objectIds.find(myObjectIdComparator) != null;
};

export const asObjectID = (id: string) => new ObjectID(id);

export const asObjectIDs = (ids: string[]) => ids.map(asObjectID);

/**
 * Gets _id from the document else returns the value
 * @returns {string}
 */
export function getObjectId(value: { _id: ObjectID } | string | ObjectID) {
  if (typeof value === 'object' && '_id' in value) return value._id.toString();
  return value.toString();
}
